var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coding"},[_c('link-model',{attrs:{"to":"/lhUI","fontSize":"15px","padding":"10px"}},[_vm._v("lhUI")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }